// Armatür çiziminde "düz mod" (L tuşu) için paylaşımlı bayrak.
// - useFixture (tesisat) L tuşunda yazar + kalıcı hatta/marker'da okur.
// - useBaseWiring (wiring) preview (updateTempLine) sırasında okur.
// Modül seviyesinde ref: useComponentWiring (mega-hook, dokunma yasağı) üzerinden
// prop threading yapmadan iki hook'un aynı durumu paylaşmasını sağlar.
// true  → hat düz (polyline) çizilir
// false → hat eğri (CatmullRom spline) çizilir (varsayılan)
export const fixtureLineModeRef = { current: false };
